import { supabase } from "./supabase";

const API_URL = import.meta.env.VITE_HQ_API_URL ?? "https://api.hq.tribalaxe.com";

async function authHeader(): Promise<HeadersInit> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) throw new Error("no_session");
  return { Authorization: `Bearer ${token}` };
}

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const auth = await authHeader();
  const headers = new Headers(init.headers ?? {});
  for (const [k, v] of Object.entries(auth)) {
    if (typeof v === "string") headers.set(k, v);
  }
  return fetch(`${API_URL}${path}`, { ...init, headers });
}

export async function apiGet<T>(path: string): Promise<T> {
  const r = await apiFetch(path);
  if (!r.ok) throw new Error(`${r.status}: ${await r.text()}`);
  return (await r.json()) as T;
}

export async function apiSend<T>(path: string, method: string, body?: unknown): Promise<T> {
  const r = await apiFetch(path, {
    method,
    headers: { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (!r.ok) throw new Error(`${r.status}: ${await r.text()}`);
  return (await r.json()) as T;
}
